import React from "react";
import CustomLoading from "../../../utils/LoadingIndicator/CustomLoading";
import { Link } from "react-router-dom";
import { API } from "../../../config";

function AuthenticatedWishListCard({
  item,
  isAddingItem,
  loadingItemId,
  cartItems,
  isRemovingProduct,
  removeItemFromCartFn,
  addItemToCartFn,
  isRemovingFromWishlist,
  removeFromWishlistFn,
  setLoadingItemId,
}) {
  const inCart = cartItems?.items?.some(
    (c) => c?.productId === item?.product?._id
  );
  // console.log("cart items: ", cartItems);
  // console.log(inCart);
  const isLoading = loadingItemId === item.product?._id;
  return (
    <div
      key={item?.product?._id}
      className="w-full max-w-[300px] bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow border-2 border-[#00000051]"
    >
      <div className="relative">
        <img
          src={`${API}/products/photo/${item?.product?._id}`}
          alt={item.name}
          className="w-full h-48 object-contain px-4 py-3"
        />
        <button
          onClick={() => removeFromWishlistFn(item.product._id)}
          disabled={isRemovingFromWishlist}
          className="absolute top-2 right-2 bg-white p-2 rounded-full shadow-md hover:bg-red-50 transition-colors"
          title="Remove from wishlist"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-red-500"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>

      <div className="p-4 h-[50%]">
        <div className="flex flex-col gap-2 justify-between items-center h-full">
          <div className="h-full w-full">
            <h3 className="text-lg font-semibold text-gray-800 line-clamp-2">
              {item?.product?.name}
            </h3>
            <p className="text-xl font-bold text-green-700">
              {item?.priceAtAdded} EGP
            </p>
            <p className="text-sm text-gray-600 line-clamp-2 h-10">
              {item?.product?.description}
            </p>
            <Link
              to={`/product/${item?.product?._id}`}
              className="text-[#DA0E1A] hover:text-red-700 font-medium text-center w-full block"
            >
              View Details
            </Link>
          </div>
          <button
            className="w-full bg-[#DA0E1A] text-white py-2 rounded hover:bg-red-700 transition-colors"
            onClick={() => {
              setLoadingItemId(item?.product?._id);
              if (inCart) {
                removeItemFromCartFn(item?.product?._id);
              } else {
                addItemToCartFn({
                  productId: item?.product?._id,
                  quantity: 1,
                });
              }
            }}
            disabled={isAddingItem || isRemovingProduct}
          >
            {isLoading && (isAddingItem || isRemovingProduct) ? (
              <CustomLoading size="1.25rem" />
            ) : inCart ? (
              "Remove From Cart"
            ) : (
              "Add To Cart"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AuthenticatedWishListCard;
